import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import useAgenzie from '../../hooks/useAgenzie';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';


/* CUSTOM FILTER TABLE CODICE DA RIFARE */
const CustomFilterTable = ({ searchNodeType, setFormDataFilter, formDataFilter, onFilteredTable, isLoadingData, isAssegnaCorso, isModalView, itsOneField, isClassView, isCorsoTelematicaAsincrona }) => {
  const userLoggedIn = useSelector(state => state.user.userData); 
  const [fieldInput, setFieldInput] = useState(searchNodeType);
  const [agenzie, setAgenzie] = useState([]);//NEW
  const {getAllAgenzie} = useAgenzie();//NEW

  useEffect(() => {
    const fetchAgenzie = async () => {
      try {
        const response = await getAllAgenzie();
        setAgenzie(response);
      } catch (error) {
        console.error('Errore nel recupero delle agenzie:', error);
      }
    };

    fetchAgenzie();
  }, []);

  useEffect(() => {
    setFieldInput(searchNodeType);
  }, [searchNodeType]);

  /*
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (value !== 'no') {
      setFormDataFilter((prevState) => ({ ...prevState, [name]: value }));
    } else {
      const { [name]: omit, ...newFormDataFilter } = formDataFilter;
      setFormDataFilter(newFormDataFilter);
    }
  };
  */

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    // --- LOGICA CORRETTA E DEFINITIVA ---
    // Se l'utente seleziona l'opzione "Qualsiasi..." (che ha un valore vuoto)
    if (value === '') {
        // Rimuoviamo la chiave dall'oggetto dei filtri.
        const { [name]: omit, ...newFormDataFilter } = formDataFilter;
        setFormDataFilter(newFormDataFilter);
    } else {
        // Altrimenti, impostiamo il valore del filtro come al solito.
        setFormDataFilter((prevState) => ({ ...prevState, [name]: value }));
    }
};
  

  const handleClearInput = (fieldName) => {
    setFormDataFilter((prevState) => {
      const newFormDataFilter = { ...prevState };
      delete newFormDataFilter[fieldName];
      return newFormDataFilter;
    });
  };
  

  return (
    <>
    {
      !isModalView ?  
    <Accordion defaultActiveKey="0">
    <Accordion.Item eventKey="0">
      <Accordion.Header><b>Filtri</b></Accordion.Header>
      <Accordion.Body>
      <div className='row'>
      {fieldInput?.map((input, index) => (
        <div key={index} className='col-sm-12 col-md-6 col-xl-4 my-3'>
            {input?.nodeType === 'input' && (
              <>
            <div className='input-group'>
                <input
                name={input?.name}
                value={formDataFilter[input?.name] || ''}
                className='form-control bg-secondary'
                onChange={handleFormChange}
                placeholder={`Cerca per ${input?.placeholder ?? input?.name}`}
                />
                {formDataFilter[input?.name] && (
                <button className='btn btn-danger' type='button' onClick={() => handleClearInput(input?.name)}>
                    <i className='bi bi-x-lg'></i>
                </button>
                )}
            </div>
              </>
            )}
             {input?.nodeType === 'date' && (
            <div className='input-group'>
                <input
                type='date'
                name={input?.name}
                value={formDataFilter[input?.name] || ''}
                className='form-control bg-secondary'
                onChange={handleFormChange}
                title={input?.placeholder || input?.name}
                />
                {formDataFilter[input?.name] && (
                <button className='btn btn-danger' type='button' onClick={() => handleClearInput(input?.name)}>
                    <i className='bi bi-x-lg'></i>
                </button>
                )}
            </div>
             ) }
          {input?.nodeType === 'select' && (
            <select
              className='form-control bg-secondary'
              name={input?.name}
              value={formDataFilter[input.name] || ''} // Modificato per usare stringa vuota come default
              onChange={handleFormChange}>

              {/* --- INIZIO NUOVA LOGICA INTELLIGENTE --- */}
              
              {/* Se vengono fornite opzioni personalizzate, usa quelle */}
              {input.options ? (
                input.options.map((option, idx) => (
                    <option key={idx} value={option.value}>{option.label}</option>
                ))
              ) : (
                <>
                  {/* Altrimenti, usa la vecchia logica di default */}
                  {input?.name === 'abilitato_web' && (
                    <>
                      <option value=''>Qualsiasi stato</option>
                      <option value='1'>Attivo</option>
                      <option value='0'>In attesa</option>
                    </>
                  )}

                  {input?.name === 'stato_pagamento' && (
                    <>
                      <option value=''>Qualsiasi tipo di pagamento</option>
                      <option value='Voucher'>Voucher</option>
                      <option value='Pagato'>Pagato dal corsista</option>
                      <option value='Non_pagato'>In attesa di pagamento dal corsista</option>
                    </>
                  )}

                  {input?.name === 'stato' && (
                    <>
                      <option value=''>Qualsiasi stato</option>
                      <option value='aperto'>Aperto</option>
                      <option value='chiuso'>Chiuso</option>
                    </>
                  )}

                  {input?.name === 'stato_contabilizzazione' && (
                    <>
                      <option value=''>Qualsiasi stato</option>
                      <option value='da_contabilizzare'>Da contabilizzare</option>
                      <option value='contabilizzato'>Contabilizzato</option>
                    </>
                  )}

                  {input?.name === 'tipo_utente' && (
                    <>
                        <option value=''>Qualsiasi ruolo</option>
                        {!isAssegnaCorso && (
                            <>
                                <option value='admin'>Admin</option>
                                <option value='partner'>Partner</option>
                                <option value='superpartner'>Superpartner</option>
                            </>
                        )}
                        <option value='course_designer'>Course designer</option>
                        <option value='docente'>Docente</option>
                        <option value='tutor'>Tutor</option>
                        <option value='corsista'>Corsista</option>
                    </>
                  )}

                  {input?.name === 'id_agenzia' && (
                    <>
                      <option value=''>Qualsiasi agenzia</option>
                      {agenzie.map((agenzia) => (
                        <option key={agenzia.id_agenzia} value={agenzia.id_agenzia}>
                          {agenzia.denominazione}
                        </option>
                      ))}
                    </>
                  )}

                  {input?.name === 'modalita_erogazione' && (
                    <>
                      <option value=''>Qualsiasi modalità di erogazione</option>
                      <option value='Presenza'>Presenza</option>
                      <option value='Telematica_Sincrona'>Telematica sincrona</option>
                      <option value='Telematica_Asincrona'>Telematica asincrona</option>
                      <option value='Telematica_Mista'>Telematica mista</option>
                      <option value='Mista_Presenza/Telematica'>Mista presenza/telematica</option>
                    </>
                  )}
                </>
              )}
              {/* --- FINE NUOVA LOGICA --- */}
              
            </select>
          )}

        </div>
      ))}
      <div className='col-sm-12 col-md-6 col-xl-4 my-3'>
        <button className='btn btn-primary w-100' onClick={onFilteredTable} disabled={isLoadingData}>
          Cerca
        </button>
      </div>
      </div>
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
      :  
      <div className='row'>
      {fieldInput?.map((input, index) => (
        <div key={index} className={`${itsOneField ? "col-sm-12" : "col-sm-12 col-md-6 col-xl-4"} my-3`}>
            {input?.nodeType === 'input' && (
              <>
            <div className='input-group'>
                <input
                name={input?.name}
                value={formDataFilter[input?.name] || ''}
                className='form-control bg-secondary'
                onChange={handleFormChange}
                placeholder={`Cerca per ${input?.placeholder ?? input?.name}`}
                />
                {formDataFilter[input?.name] && (
                <button className='btn btn-danger' type='button' onClick={() => handleClearInput(input?.name)}>
                    <i className='bi bi-x-lg'></i>
                </button>
                )}
            </div>
              </>
            )}
             {input?.nodeType === 'date' && (
            <div className='input-group'>
                <input
                type='date'
                name={input?.name}
                value={formDataFilter[input?.name] || ''}
                className='form-control bg-secondary'
                onChange={handleFormChange}
                title={input?.placeholder || input?.name}
                />
                {formDataFilter[input?.name] && (
                <button className='btn btn-danger' type='button' onClick={() => handleClearInput(input?.name)}>
                    <i className='bi bi-x-lg'></i>
                </button>
                )}
            </div>
             ) }
          {input?.nodeType === 'select' && (
            <select
              className='form-control bg-secondary'
              name={input?.name}
              value={formDataFilter[input.name] || 'no'}
              onChange={handleFormChange}>
                
             {
                input?.name === "abilitato_web" && (
                    <>
                    <option value='no'>Qualsiasi stato</option>
                    <option value='1'>Attivo</option>
                    <option value='0'>In attesa</option>
                    </>        
                )
             }
             {
                // ticket
                input?.name === "stato" && (
                    <>
                    <option value='no'>Qualsiasi stato</option>
                    <option value='aperto'>Aperto</option>
                    <option value='chiuso'>Chiuso</option>
                    </>        
                )
             }   
             {
                input?.name === "tipo_utente" && (
                    <>
                    <option value='no'>Qualsiasi ruolo</option>
                    {!isAssegnaCorso && 
                    (
                      <>
                      <option value='admin'>Admin</option>
                      <option value='partner'>Partner</option>
                      </>

                    )}
                    <option value='course_designer'>Course designer</option>
                    {/* {(isClassView || isCorsoTelematicaAsincrona) && (
                    <option value='corsista'>Corsista</option>
                    )} */}
                    <option value='docente'>Docente</option>
                    <option value='tutor'>Tutor</option>
                    <option value='corsista'>Corsista</option>
                    </>
                )
             }   
             {
                input?.name === "modalita_erogazione" && (
                    <>
                    <option value='no'>Qualsiasi modalità di erogazione</option>
                    <option value='Presenza'>Presenza</option>
                    <option value='Telematica_Sincrona'>Telematica sincrona</option>
                    <option value='Telematica_Asincrona'>Telematica asincrona</option>
                    <option value='Telematica_Mista'>Telematica mista</option>
                    <option value='Mista_Presenza/Telematica'>Mista presenza/telematica</option>
                    </>
                )
             }   
            </select>
          )}
        </div>
      ))}
      <div className={`${itsOneField ? "col-sm-12" : "col-sm-12 col-md-6 col-xl-4"} my-3`}>
        <button className='btn btn-primary w-100' onClick={onFilteredTable} disabled={isLoadingData}>
          Cerca
        </button>
      </div>
      </div>
    }
    </>
  );
};

export default CustomFilterTable;
